
import React from 'react';
import { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import VideoSection from './components/VideoSection';
import About from './components/About';
import Services from './components/Services';
import Process from './components/Process';
import Portfolio from './components/Portfolio';
// import CaseStudies from './components/CaseStudies';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  // Example state hook – can be expanded as needed
  const [isLoaded, setIsLoaded] = useState(true);

  // Basic error handling for unexpected rendering issues
  if (!isLoaded) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <p className="text-gray-600">Loading...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <VideoSection />
      <About />
      <Services />
      <Process />
      <Portfolio />
      {/* <CaseStudies /> */}
      <Contact />
      <Footer />
    </div>
  );
}
